/**
 * Every string the feed shows, so a caller can hand in its own.
 *
 * The defaults are English and are what Framework pages use. NewForm One
 * speaks English and Spanish from its creator catalogue (`videos.feed`), and
 * no string on `/one` may be hardcoded, so its callers build this object
 * from that catalogue and pass it as `labels`. A partial override is merged
 * over the defaults. Same arrangement as `VideoReviewLabels`.
 */
export type VideoFeedLabels = {
  close: string;
  mute: string;
  unmute: string;
  play: string;
  pause: string;
  previous: string;
  next: string;
  loadingMore: string;
  /** Under the last item, for a feed long enough to have an end. */
  end: string;
  failed: string;
  retry: string;
};

export const DEFAULT_VIDEO_FEED_LABELS: VideoFeedLabels = {
  close: "Close",
  mute: "Mute",
  unmute: "Unmute",
  play: "Play video",
  pause: "Pause video",
  previous: "Previous video",
  next: "Next video",
  loadingMore: "Loading more videos…",
  end: "That’s everything",
  failed: "Couldn’t play this video",
  retry: "Try again",
};
